<template>
  <div class="prescription">
    <div class="bd">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <div class="block searchTime mainItem">
            <el-date-picker
              v-model="time"
              type="daterange"
              align="center"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd"
              @change="timeChange"
            ></el-date-picker>
          </div>
        </div>
        <div class="text lis-bd" style="min-height: 300px">
          <div v-if="listData.length != 0" class="listWarpper">
            <el-card
              shadow="hover"
              v-for="item in listData"
              :key="item.index"
              style="margin-bottom: 10px"
            >
              <div class="content">
                <div class="c_img">
                  <img :src="item.memberAvatarText || defalutAvatar" alt />
                </div>
                <div class="content-right">
                  <div class="text centerBox">
                    <p>姓名：{{ item.patient.patientName }}</p>
                    <p>年龄：{{ item.patient.patientAge }}</p>
                    <!-- <p>科室：{{ item.department_name }}</p> -->
                    <p>
                      进度状态：
                      <!-- 状态 
                      0未审核 
                      3 一级药师审核驳回 
                      5 一级药师未签字(通过处方)
                      6一级药师已审核(复核药师待审核)
                      7 复核药师未签字(驳回处方)
                      8 复核药师驳回
                      9 复核药师未签字
                      10 复核药师审核通过【报告待生成】
                      100报告生成-->
                      <!-- 已出报告  -->
                      <el-tag
                        :type="
                          item.recipe.status === 11810
                            ? 'success'
                            : item.recipe.status === 11811
                            ? 'info'
                            : item.recipe.status === 11803 ||
                              item.recipe.status === 11804
                            ? 'danger'
                            : ''
                        "
                        effect="plain"
                        >{{ PRESCRIPTION_STATUS[item.recipe.status] }}</el-tag
                      >
                    </p>
                  </div>
                  <div class="text right_box">
                    <el-button
                      v-if="auditStatus.indexOf(item.recipe.status) != -1"
                      type="primary"
                      class="signature"
                      @click="auditVisible(item)"
                      >{{ PRESCRIPTION_BUTTON[item.recipe.status] }}</el-button
                    >
                    <p class="c_btn" @click="reportDetail(item.recipe)">
                      查看详情
                    </p>
                    <p class="c_time">{{ item.patient.gmtCreate }}</p>
                  </div>
                </div>
              </div>
            </el-card>
            <div class="page">
              <el-pagination
                @current-change="currentPageChange"
                :page-size="pageList.pageSize"
                :current-page="pageList.currentPage"
                layout="total, prev, pager, next"
                :total="pageList.total"
              ></el-pagination>
            </div>
          </div>
          <div v-else class="empty">
            <emptyData />
          </div>
        </div>
      </el-card>
    </div>
    <!-- 审核 -->
    <AuditDialog
      :auditDialogVisible="auditDialogVisible"
      :userItem="userItem"
      @changeShow="showAddOrUpdate"
      @refresh-item="refresh"
    ></AuditDialog>
  </div>
</template>

<script>
const defalutAvatar = require("@/assets/images/defaultIcon.jpg");
import { getOrderList } from "@/api";
import { prescriptionSign, prescriptionSignReview } from "@/api/doctor";
import pdf from "vue-pdf";
import util from "@/utils";
import emptyData from "@/components/common/emptyData.vue";
import { PRESCRIPTION_STATUS, PRESCRIPTION_BUTTON } from "@/utils/constants.js";
import AuditDialog from "@/components/auditDialog";

export default {
  name: "auditPR",
  components: { pdf, emptyData, AuditDialog },
  props: {},
  data() {
    return {
      PRESCRIPTION_STATUS,
      PRESCRIPTION_BUTTON,
      auditDialogVisible: false,
      userItem: {},
      userType: util.getStore("userType"),
      listData: [],
      pageList: { pageSize: 5, currentPage: 1 },
      defalutAvatar: defalutAvatar,
      auditStatus: "11802,11803,11804,11805", // 待审核状态
      time: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    auditVisible(item) {
      if (item.recipe.status == "11802") {
        //审核药师待审核(医生已签字)
        this.auditDialogVisible = true;
        this.userItem = item;
      } else if (item.recipe.status == "11804") {
        // 复核药师待复核(审核药师已签字)
        this.auditDialogVisible = true;
        this.userItem = item;
      } else {
        this.signature(item);
      }
    },
    /*
     * 签字接口
     */
    async signature(item) {
      const params = {
        recipeId: item.recipe.id,
      };
      let res;
      if (item.recipe.status == "11803") {
        //审核药师待签字(审核药师已审核)
        res = await prescriptionSign(params);
      } else if (item.recipe.status == "11805") {
        // 复核药师待复核(审核药师已签字)
        res = await prescriptionSignReview(params);
      }
      if (res.code == 1) {
        window.location.href = res.data;
        // this.$message({
        //   message: "设置成功",
        //   type: "success",
        // });
        this.getReportList();
      } else {
        this.$message({
          message: "设置失败",
          type: "warning",
        });
      }
    },
    //时间搜索
    timeChange() {
      this.getReportList();
    },
    //分页
    currentPageChange(val) {
      this.pageList.currentPage = val;
      this.getReportList();
    },
    /**
     * 点击预览详情
     */
    reportDetail(item) {
      console.log("item:", item);
      let query = {
        id: item.id,
        orderNo: item.orderNo,
      };
      this.$router.push({
        path: "/index/user/auditPrescription/prescriptionDetails",
        query,
      });
    },

    /*
     * 报告列表
     */
    async getReportList() {
      const that = this;
      let startTime;
      let endTime;
      if (that.time) {
        startTime = that.time[0];
        endTime = that.time[1];
      }
      let params = {
        status: "11802", // 待审核
        startDate: startTime,
        endDate: endTime,
        currentPage: that.pageList.currentPage,
        pageSize: that.pageList.pageSize,
      };
      let res = await getOrderList(params);
      if (res.code == 1) {
        this.listData = res.data.dataList;
        this.pageList.total = Number(res.data.totalCount);
      }
    },
    /*
     * 刷新
     */
    refresh() {
      this.getReportList();
      this.getUserInfo();
    },
    // 监听 子组件弹窗关闭后触发，有子组件调用
    showAddOrUpdate(data) {
      if (data === "false") {
        this.auditDialogVisible = false;
      } else {
        this.auditDialogVisible = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.prescription {
  width: 80%;
  margin: 0 auto;
}
.listWarpper {
  margin-top: 10px;
}
.content {
  display: flex;
  padding: 20px;
  .c_img {
    // flex: 0 0 10%;
    width: 100px;
    height: 100px;
    text-align: center;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100px;
    }
  }
  .content-right {
    flex: 1;
    display: flex;
    .text {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    .signature {
      align-content: center;
      margin: 0 auto;
    }
    .centerBox {
      flex: 0 0 65%;
      margin-left: 15px;
    }
    .right_box {
      // flex: 0 0 25%;
      text-align: center;
      .signature {
        margin-bottom: 20px;
      }
      .c_btn {
        color: #fc701a;
        margin-bottom: 20px;
        cursor: pointer;
      }
      .c_time {
        color: rgb(167, 157, 157);
      }
    }
  }
}
.header-tab {
  display: flex;
  justify-content: space-around;
  .prescription_title_card {
    width: 200px;
    text-align: center;
  }
}
.bd {
  margin: 20px 0;
  .mainItem {
    float: left;
  }
  .page {
    text-align: center;
  }
}
.mainItem:nth-child(2) {
  margin-left: 20px;
}
.pdf span {
  display: block !important;
}
.prescription_card {
  //   height: 130px;
  margin-top: 20px;
}
.prescription_card_p_title {
  font-weight: 700;
  margin-bottom: 10px;
}

.prescription_title_card {
  background-color: #f6f7fb;
}
.prescription_title_content {
  padding: 15px 0 0 0;
  .text {
    .title {
      font-size: 22px;
      margin-top: 10px;
    }
    .num {
      font-size: 18px;
      margin-top: 10px;
      color: rgba(000, 00, 0, 0.8);
    }
  }
}

.prescription_title_img img {
  width: 60px;
}
.prescription .empty {
  width: 10%;
  margin: 0 auto;
  margin-top: 10%;
}
.prescription .right_box .el-tag {
  margin: 0 auto;
  width: 30%;
}
</style>
